import React, { useEffect, useState } from 'react';


const ScrollToTopButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 600) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="scroll-to-top-wrapper">
      <button
        type="button"
        onClick={scrollToTop}
        className={`scroll-to-top-btn ${show ? 'scroll-to-top-btn--visible' : ''}`}
        aria-label="Back to top"
      >
        <span className="scroll-to-top-arrow">↑</span>
      </button>
    </div>
  );
};

export default ScrollToTopButton;
